module.exports = __webpack_public_path__ + "media/images/img/seikousya/medley-bebc3c450d02338d65e6704cfe0b168f.png";